import script from "./storage-service.vue?vue&type=script&lang=ts"
export * from "./storage-service.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__